import * as React from 'react';

import { MAX_VALUE, MIN_VALUE } from './constants';
import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { getRangeValue } from '../../../../packages/JsonQuery';
import { getNormalizedValue } from '../../../common/utils/getNormalizedValue';
import { Filter } from '../../components/Filter';
import { PriceInputs } from '../../components/PriceInputs';
import { EFiltersMobileTestId } from '../../types';

interface IPriceInputsContainerProps {
  onMinBlur: () => void;
  onMaxBlur: () => void;
}

export function PriceInputsContainer({ onMinBlur, onMaxBlur }: IPriceInputsContainerProps) {
  const { jsonQuery, onChange } = useFiltersContext();
  const price = getRangeValue('price')(jsonQuery);
  const { gte: priceMin = null, lte: priceMax = null } = price || {};
  const maxInputRef = React.useRef<HTMLInputElement>(null);

  const handlePriceMinChange = React.useCallback(
    (value: number | null) => {
      onChange({ action: 'setPriceMin', arguments: [value] });
    },
    [onChange],
  );

  const handlePriceMaxChange = React.useCallback(
    (value: number | null) => {
      onChange({ action: 'setPriceMax', arguments: [value] });
    },
    [onChange],
  );

  const normalizedMinPrice = getNormalizedValue(priceMin, MIN_VALUE, MAX_VALUE) || undefined;
  const normalizedMaxPrice = getNormalizedValue(priceMax, MIN_VALUE, MAX_VALUE) || undefined;

  React.useEffect(() => {
    if (maxInputRef.current) {
      maxInputRef.current.querySelector('input')?.focus();
    }
  }, []);

  return (
    <Filter id="filter_price" contentPadding={false}>
      <PriceInputs
        min={MIN_VALUE}
        max={MAX_VALUE}
        minValue={normalizedMinPrice}
        maxValue={normalizedMaxPrice}
        minTestId={EFiltersMobileTestId.PriceMinFilterInput}
        maxTestId={EFiltersMobileTestId.PriceMaxFilterInput}
        onMinChange={handlePriceMinChange}
        onMaxChange={handlePriceMaxChange}
        onMinBlur={onMinBlur}
        onMaxBlur={onMaxBlur}
        ref={maxInputRef}
      />
    </Filter>
  );
}
